export const STEP_DISPLAY_NAMES = {
  step_function: 'Provisioning',
  instance_launch: 'Instance Launch',
  post_deployment: 'Post-Deployment',
  agent_install: 'Arch Agent',
  pcoip_install: 'PCoIP Agent',
  dcv_install: 'NICE DCV',
  parsec_install: 'Parsec',
  cloudwatch_agent: 'CloudWatch',
  chef_cookbooks: 'Chef Run List',
  domain_join: 'Domain Join',
};

export const parseMilestoneStatus = status => {
  const [step, state] = status.split(':');
  return { step, state, displayName: STEP_DISPLAY_NAMES[step] || step };
};
